export default "__VITE_ASSET__in0gek$F__"